import { inject, named } from '../decorator';
import { Provider } from './contribution-protocol';
export var contrib = function contrib(token) {
  return function ( // eslint-disable-next-line @typescript-eslint/no-explicit-any
  target, targetKey, index) {
    named(token)(target, targetKey, index);
    inject(Provider)(target, targetKey, index);
  };
};